/* qtrat: وظيفتان:
   أولاً — زر «إضافة للسلة» على بطاقات المنتجات يتحول لعدّاد كمية بمكانه بعد الإضافة.
   ثانياً — يضيف تاريخ الانتهاء داخل سطر عنوان المنتج بالسلة — بنفس السطر، بلا إضافة ارتفاع.
   مصدر التاريخ: {root}products/<handle>?view=expiry عبر templates/product.expiry.liquid
   مهم: البادئة من Shopify.routes.root — على النسخة الإنجليزية بتصير /en/
   وإلا بيرجع التاريخ بالعربي داخل سلة إنجليزية.
   مقصود بدل تعديل sections/main-cart.liquid (46KB) و sections/cart-drawer.liquid (72KB).
   النصوص من window.qtratStrings.ui — انظر snippets/qtrat-strings.liquid.
   كل الأرقام من /cart.js مباشرة — ما في عدّ محلي يمكن يختلف عن السلة الحقيقية. */
(function () {
  var CSS =
    /* زر الإضافة: خلفية شفافة بالكامل — صورة المنتج تبان من خلفه.
       الإطار والأيقونة بلون كامل التشبّع وسماكة أعلى حتى يبقى الزر بائناً،
       مع هالة بيضاء مزدوجة تفصله عن الصور الغامقة.
       عند اللمس يمتلئ أخضر ليبيّن أنه انضغط. */
    '.hdt-card-product__btn-ultra{background:transparent!important;background-color:transparent!important;color:#025437!important;border:2px solid #025437!important;box-shadow:none!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;filter:drop-shadow(0 0 1px #fff) drop-shadow(0 0 3px rgba(255,255,255,.95));transition:background-color .15s,color .15s}'
    /* الأيقونة 16px داخل مربع 32px كانت ضايعة — كبّرناها وثخّنّا حدّها */
    + '.hdt-card-product__btn-ultra svg{width:20px!important;height:20px!important;fill:currentColor}'
    + '.hdt-card-product__btn-ultra:hover,.hdt-card-product__btn-ultra:focus,.hdt-card-product__btn-ultra:active{background-color:#025437!important;color:#fff!important;border-color:#025437!important;filter:none}'
    /* العدّاد فيه رقم لازم يُقرأ، فخلّينا خلفية خفيفة جداً بدل الشفافية الكاملة */
    + '.qtrat-qty{display:inline-flex;align-items:center;background:rgba(255,255,255,.5);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);border:2px solid #025437;border-radius:999px;padding:3px}'
    + '.qtrat-qty button{width:30px;height:30px;border:0;background:transparent;color:#025437;font-family:inherit;font-size:19px;font-weight:700;line-height:1;cursor:pointer;border-radius:999px;padding:0}'
    + '.qtrat-qty button:active{background:rgba(2,84,55,.16)}'
    + '.qtrat-qty span{min-width:26px;text-align:center;font-family:inherit;font-size:15px;font-weight:700;color:#025437}'
    + '.qtrat-qty[data-busy]{opacity:.55;pointer-events:none}'
    + '.qtrat-cart-exp{font-size:.82em;font-weight:400;color:var(--qt-muted,#4c6457);white-space:nowrap}'
    + '#qtrat-toast{position:fixed;z-index:9999;bottom:22px;left:50%;transform:translateX(-50%);max-width:88vw;background:#025437;color:#fff;font-family:inherit;font-size:14px;line-height:1.6;padding:11px 18px;border-radius:12px;box-shadow:0 6px 24px rgba(0,0,0,.28);opacity:0;transition:opacity .18s}'
    + '#qtrat-toast[show]{opacity:1}';

  var busy = false, toastTimer = null, expCache = {}, expTimer = null;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function ui(key, fallback) {
    var u = window.qtratStrings && window.qtratStrings.ui;
    return (u && u[key]) || fallback;
  }

  function cartStr(key, uiKey) {
    var s = window.qtratStrings && window.qtratStrings.cart && window.qtratStrings.cart[key];
    if (s && s.toLowerCase().indexOf('translation missing') === -1) return s;
    return ui(uiKey, '');
  }

  function once() {
    if (document.getElementById('qtrat-qty-css')) return;
    var s = document.createElement('style');
    s.id = 'qtrat-qty-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  function toast(msg) {
    if (!msg) return;
    once();
    var t = document.getElementById('qtrat-toast');
    if (!t) { t = document.createElement('div'); t.id = 'qtrat-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.setAttribute('show', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.removeAttribute('show'); }, 2800);
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function setCount(n) {
    var els = document.querySelectorAll('hdt-cart-count');
    // الكتابة تُنشئ عقدة نصية جديدة فيلتقطها MutationObserver ويعيد الجلب —
    // حلقة لا تنتهي. نكتب فقط عند اختلاف القيمة.
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent != n) els[i].textContent = n;
    }
    var d = document.querySelector('[ref="hdt-cart"]');
    if (d) d.dataset.count = n;
  }

  function build(vid, q) {
    var w = document.createElement('div');
    w.className = 'qtrat-qty';
    w.setAttribute('data-vid', vid);
    w.innerHTML = '<button type="button" data-d="-1" aria-label="' + ui('dec', 'إنقاص') + '">−</button>'
      + '<span>' + q + '</span>'
      + '<button type="button" data-d="1" aria-label="' + ui('inc', 'زيادة') + '">+</button>';
    return w;
  }

  function sync(cart) {
    once();
    var map = {}, i;
    for (i = 0; i < cart.items.length; i++) map[cart.items[i].variant_id] = cart.items[i].quantity;
    setCount(cart.item_count);
    var boxes = document.querySelectorAll('.hdt-card-product .hdt-product-btns');
    for (i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var input = box.querySelector('input[name="id"]');
      if (!input) continue;
      var vid = input.value, q = map[vid] || 0;
      var frm = box.querySelector('wrapp-hdt-pr-frm');
      var st = box.querySelector('.qtrat-qty');
      if (q > 0) {
        if (frm) frm.hidden = true;
        if (!st) { st = build(vid, q); box.appendChild(st); }
        else {
          var sp = st.querySelector('span');
          if (sp.textContent != q) sp.textContent = q;
        }
        st.removeAttribute('data-busy');
      } else {
        if (st) st.remove();
        if (frm) frm.hidden = false;
      }
    }
  }

  function expiryFor(handle) {
    if (expCache[handle] !== undefined) return Promise.resolve(expCache[handle]);
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=expiry')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        t = (t || '').trim();
        if (t.length > 60 || t.indexOf('<') > -1) t = '';
        expCache[handle] = t;
        return t;
      })
      .catch(function () { expCache[handle] = ''; return ''; });
  }

  function cartExpiry() {
    once();
    var rows = document.querySelectorAll('.hdt-cart-item, .hdt-mini-cart__line, [class*="cart-drawer__item"], tr[id^="CartItem"]');
    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        if (row.querySelector('.qtrat-cart-exp')) return;
        var a = row.querySelector('a[href*="/products/"]');
        var title = row.querySelector('[class*="title"]');
        if (!a || !title) return;
        var handle = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
        if (!handle) return;
        expiryFor(handle).then(function (txt) {
          if (!txt || row.querySelector('.qtrat-cart-exp')) return;
          var s = document.createElement('span');
          s.className = 'qtrat-cart-exp';
          s.textContent = ' · ' + txt;
          title.appendChild(s);
        });
      })(rows[i]);
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  async function apply(vid, delta, node) {
    if (busy) return;
    busy = true;
    if (node) node.setAttribute('data-busy', '1');
    try {
      var cart = await getCart(), line = null, i, res;
      for (i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(vid)) { line = cart.items[i]; break; }
      }
      if (!line) {
        if (delta > 0) {
          res = await post(root() + 'cart/add.js', { id: String(vid), quantity: 1 });
          if (!res.ok) toast(cartStr('max_already_in_cart', 'maxed'));
        }
      } else {
        var q = line.quantity + delta;
        if (q < 0) q = 0;
        res = await post(root() + 'cart/change.js', { id: line.key, quantity: q });
        if (!res.ok && delta > 0) toast(cartStr('max_already_in_cart', 'maxed'));
      }
      sync(await getCart());
      document.dispatchEvent(new CustomEvent('qtrat:cart-changed'));
      document.dispatchEvent(new CustomEvent('cart:reload'));
    } catch (e) {
      if (node) node.removeAttribute('data-busy');
    }
    busy = false;
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (!f.closest || !f.closest('.hdt-card-product')) return;
    var input = f.querySelector('input[name="id"]');
    if (!input) return;
    ev.preventDefault();
    ev.stopPropagation();
    apply(input.value, 1, null);
  }, true);

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.qtrat-qty button');
    if (!b) return;
    ev.preventDefault();
    var w = b.parentElement;
    apply(w.getAttribute('data-vid'), parseInt(b.getAttribute('data-d'), 10), w);
  });

  // زر «ناقص» في سطر السلة عند الكمية ١ = حذف مباشر. الثيم يوقفه عند min=1،
  // فنلتقط النقرة في طور الالتقاط قبل مكوّن الثيم ونحذف السطر بدل تثبيته.
  // بلا رسالة تأكيد: الحذف هنا رخيص التراجع، والتأكيد ضريبة على كل عملية.
  // الزر والحقل شقيقان داخل الغلاف — صفحة السلة تستعمل <hdt-quantity-wrapp>
  // والدرج يستعمل [data-quantity-wrapper]، فنعتمد على الأب المباشر لا على اسم الغلاف.
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.hdt-quantity__button[name="minus"]');
    if (!b || !b.parentElement) return;
    var input = b.parentElement.querySelector('.hdt-quantity-input');
    if (!input || parseInt(input.value, 10) !== 1) return;
    var line = parseInt(input.getAttribute('data-index'), 10);
    if (!line || busy) return;
    ev.preventDefault();
    ev.stopPropagation();
    busy = true;
    var wrap = b.parentElement;
    wrap.setAttribute('data-busy', '1');
    post(root() + 'cart/change.js', { line: line, quantity: 0 })
      .catch(function () {})
      .then(function () {
        busy = false;
        wrap.removeAttribute('data-busy');
        getCart().then(sync).catch(function () {});
        document.dispatchEvent(new CustomEvent('cart:reload'));
      });
  }, true);

  function boot() { getCart().then(sync).catch(function () {}); cartExpiry(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  ['cart:updated', 'hdt:cart:updated', 'shopify:section:load', 'hdt:products:loaded'].forEach(function (ev) {
    document.addEventListener(ev, boot);
  });
  new MutationObserver(function () {
    clearTimeout(expTimer);
    expTimer = setTimeout(function () { getCart().then(sync).catch(function () {}); cartExpiry(); }, 250);
  }).observe(document.body, { childList: true, subtree: true });
})();
